import React, { Fragment } from "react";

class Footer extends React.Component {
  render() {
    return (
      <Fragment>
        <div className="app-footer">
          <div className="app-footer__inner">
            <div className="app-footer-left">
              PT Yasunaga Indonesia &copy; 2021
            </div>
            <div className="app-footer-right"></div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Footer;
